import makeStyles from '@mui/styles/makeStyles';
import palette from 'core/theme/palette';

export const useStyles = makeStyles((theme) => ({
    titleDialog: {
        marginBottom: '1rem',
    },
    formContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '25rem',
        marginTop: '1rem',
    },
    fieldCustom: {
        width: '100%',
        marginBottom: theme.spacing(2),
        borderRadius: '4px',
        fontSize: '1rem',
    },
    selectCustom: {
        width: '100%',
        marginBottom: theme.spacing(2),
        padding: theme.spacing(1),
        border: '1px solid #ccc',
        borderRadius: '4px',
        fontSize: '1.5rem',
    },
    createButton: {
        marginBottom: theme.spacing(1),
        fontSize: '0.8rem',
        color: 'white',
    },
    buttonContainer: {
        display: 'flex',
        marginTop: '1rem',
        direction: 'row',
        justifyContent: 'flex-end',
    },
    iconButton: {},
    phoneNumber: {
        marginBottom: '0.8rem',
    },
}));
